<template>
  <section class="sec_home-voice">
    <PartsHomeTitle title="ご愛用者様の声" subtitle="ご愛用者様インタビュー" />

    <div class="voice-banner">
      <img src="/image/img_home-voice-letter.png" class="pc-only" alt="ご愛用者さまインタビュー" />
      <img
        src="/image/img_home-voice-letter_sp.png"
        class="sp-only"
        alt="ご愛用者さまインタビュー"
      />
      <!-- SP のみ手紙の下に並ぶ追加画像。上の画像と同じ内容を指すので alt は空にする -->
      <img src="/image/img_home-voice02_sp.png" class="sp-only voice-banner_img" alt="" />
    </div>

    <PartsBtnRound to="/voice" label="ご愛用者様の声を見る" />
  </section>
</template>

<script setup lang="ts">
/**
 * 支給デザインの `sec_home-voice`（ご愛用者様の声）。
 * バナー画像とボタンだけのセクションで、記事の出し分けは持たない。
 */
</script>
